import React, { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";
import { isEnterOrSpace } from "Utils/utils";

import styles from "./styles";

interface Props {
  id: string;
  title?: string;
  headingLevel?: number;
  children?: React.ReactNode;
  expanded?: boolean;
  onClick?: () => void;
  selectedTrail?: string;
  itemCount?: number;
}

const AccordionItem = (props: Props) => {
  const {
    children,
    expanded,
    headingLevel,
    id,
    title,
    onClick,
    selectedTrail,
    itemCount,
  } = props;
  const useStyles = createUseStyles(styles);
  const classes = useStyles(props);

  const [isExpanded, setIsExpanded] = useState(expanded);

  const buttonId = `${id}--button`;
  const panelId = `${id}--panel`;

  const toggleIsExpanded = () => {
    if (onClick) {
      onClick();
    }
    setIsExpanded((val) => !val);
  };

  // separate useEffect needed to handle closing the accordion when another one is opened
  useEffect(() => {
    setIsExpanded(selectedTrail === title);
  }, [selectedTrail, title]);

  return (
    <div className={classes.accordionItem}>
      <div role="heading" aria-level={headingLevel}>
        <div
          id={buttonId}
          role="button"
          tabIndex={0}
          className={classes.accordionButton}
          aria-label={`${title}. ${itemCount} stops`}
          aria-expanded={isExpanded}
          aria-controls={panelId}
          onClick={toggleIsExpanded}
          onKeyDown={(event) => {
            if (isEnterOrSpace(event)) {
              toggleIsExpanded();
            }
          }}
        >
          <span
            className={`${classes.accordionIcon} ${
              isExpanded ? classes.accordionIconExpanded : ""
            }`}
          />
          {title}
        </div>
      </div>
      <div
        id={panelId}
        role="region"
        aria-labelledby={buttonId}
        className={`${classes.accordionPanel} ${
          isExpanded ? "" : classes.hidden
        }`}
      >
        {isExpanded ? children : null}
      </div>
    </div>
  );
};

AccordionItem.defaultProps = {
  children: null,
  headingLevel: 2,
  expanded: false,
  title: "",
  onClick: null,
  selectedTrail: "",
  itemCount: 0,
};

export default AccordionItem;
try {
    // @ts-ignore
    AccordionItem.displayName = "AccordionItem";
    // @ts-ignore
    AccordionItem.__docgenInfo = { "description": "", "displayName": "AccordionItem", "props": { "id": { "defaultValue": null, "description": "", "name": "id", "required": true, "type": { "name": "string" } }, "title": { "defaultValue": { value: "" }, "description": "", "name": "title", "required": false, "type": { "name": "string" } }, "headingLevel": { "defaultValue": { value: 2 }, "description": "", "name": "headingLevel", "required": false, "type": { "name": "number" } }, "expanded": { "defaultValue": { value: false }, "description": "", "name": "expanded", "required": false, "type": { "name": "boolean" } }, "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": false, "type": { "name": "() => void" } }, "selectedTrail": { "defaultValue": { value: "" }, "description": "", "name": "selectedTrail", "required": false, "type": { "name": "string" } }, "itemCount": { "defaultValue": { value: 0 }, "description": "", "name": "itemCount", "required": false, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Accordion/AccordionItem/AccordionItem.tsx#AccordionItem"] = { docgenInfo: AccordionItem.__docgenInfo, name: "AccordionItem", path: "src/shared/components/Accordion/AccordionItem/AccordionItem.tsx#AccordionItem" };
}
catch (__react_docgen_typescript_loader_error) { }